// Transitional alias map for warehouse names.
//
// Background: warehouse "Pembroke Dock" was renamed to "Pembroke" via
// the admin Settings rename feature. The cascade updated every Postgres
// table and most Mongo collections, but ~87 legacy device records were
// intentionally left on the old name. While that data is in flight,
// any UI that filters / counts / groups by warehouse must treat the
// two names as equivalent — otherwise a Pembroke admin sees zero of
// their own devices on the Hardware page.
//
// New aliases can be added here as they appear; the helper only kicks
// in when the source data carries a recognised legacy value, so adding
// or removing entries is safe. Once a legacy value disappears from the
// DB entirely the corresponding entry can be dropped.

const LEGACY_TO_CANONICAL: Record<string, string> = {
    "Pembroke Dock": "Pembroke",
};

/**
 * Map a possibly-legacy warehouse name onto its current canonical name.
 * Returns the input unchanged if it isn't aliased. Use this for any
 * filter / count / group comparison in the UI so renamed warehouses
 * still match records that haven't been migrated yet.
 */
export const canonicalWarehouse = (w: string | null | undefined): string => {
    if (!w) return "";
    return LEGACY_TO_CANONICAL[w] ?? w;
};

/**
 * Whether two warehouse strings refer to the same canonical site,
 * accounting for legacy aliases. Symmetric.
 */
export const sameWarehouse = (a: string | null | undefined, b: string | null | undefined): boolean =>
    !!a && !!b && canonicalWarehouse(a) === canonicalWarehouse(b);
